
export {} from '@clayui/breadcrumb';
import __x__ from '@clayui/breadcrumb';export default __x__;